<style src="./User.scss" lang="scss" scoped></style>
<template lang="html">
  <section class="permission">
    <content-header path="Cadastro / Usuário"/>

    <form v-on:submit.prevent="searchSubmit">
      <section class="form-box row">
        <textbox
        v-model="searchText"
        label="Buscar usuário"
        placeholder="Digite o nome usuário"
        class="col-9"/>

        <button class="btn-primary col-3" @click="addNew">
          <icon-add />
          <span class="hide-md">Inserir Novo</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <user-map
        :list-data="listData"
        @edit="edit"
        @refresh-list="loadAll"/>
    </section>

    <right-side-panel
      ref="rspNew"
      title="Novo Usuário"
      v-shortkey="['ctrl', 'alt', 'n']"
      @shortkey="addNew">
      <new-user
        @refresh-list="refreshList" />
    </right-side-panel>

    <right-side-panel ref="rspEdit" title="Editar Usuário">
      <edit-user
        :edit-data="editData"
        @refresh-list="refreshList" />
    </right-side-panel>
  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import { Textbox } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { UserMap } from './components'
import { NewUser, EditUser } from './right-panel'
import { ListUsers } from '@/brain/record/user'

export default {
  name: 'User',
  components: {
    ContentHeader,
    RightSidePanel,
    Textbox,
    IconAdd,
    IconEmpty,
    UserMap,
    NewUser,
    EditUser
  },
  data () {
    return {
      searchText: '',
      listData: [],
      editData: {},
      showNewRightPanel: false
    }
  },
  mounted () {
    this.loadAll()
  },
  methods: {
    searchSubmit () {},
    refreshList () {
      this.loadAll()
    },
    loadAll () {
      ListUsers()
        .then((result) => {
          this.listData = result
        })
    },
    addNew () {
      this.$nextTick(() => {
        this.$refs.rspNew.showPanel()
      })
    },
    addedSuccessful () {
      this.showNewRightPanel = false
      this.loadAll()
    },
    edit (pId) {
      this.editData = this.listData[pId]
      this.$nextTick(() => {
        this.$refs.rspEdit.showPanel()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/user/User.vue